import {useEffect} from 'react';
import {connect} from 'react-redux';

import SimpleChunk from './SimpleChunk';

const AutoLoadChunk = ({index, loaded, isLoaded, onLoad, ...props}) => {
    useEffect(
        () => {
            if (loaded === false) onLoad(index, isLoaded);
        },
        [loaded, isLoaded, index, onLoad],
    );

    return <SimpleChunk {...props} index={index} loaded={loaded} />;
};

const mapStateToProps = ({animationStart, animationStop}, {index, available}) => ({
    isLoaded: available && index >= animationStart && index <= animationStop,
});

export default connect(mapStateToProps)(AutoLoadChunk);
